import {
  Control,
  Controller,
  FieldError,
  FieldErrors,
  RegisterOptions,
} from 'react-hook-form'

import { TextInput, TextInputProps } from '@hivewatch/dark'

type OwnedProps = 'value' | 'onChange' | 'hasWarning' | 'warningText'

export interface ControlledTextInputIProps
  extends Omit<TextInputProps, OwnedProps> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: Control<any>
  errors: FieldErrors
  name: string
  rules?: RegisterOptions
  defaultValue?: string
  /** Extra listener fired alongside the form update, for side effects. */
  onValueChange?: (value: string) => void
}

/**
 * Binds the dark `TextInput` to react-hook-form via `Controller`, mapping the
 * field's error to the input's `hasWarning`/`warningText`. Keeps the dark
 * package form-library-agnostic — the RHF glue lives here, once.
 */
export const ControlledTextInput = ({
  control,
  errors,
  name,
  rules,
  defaultValue = '',
  onValueChange,
  ...rest
}: ControlledTextInputIProps) => (
  <Controller
    control={control}
    defaultValue={defaultValue}
    name={name}
    render={({ value, onChange }) => {
      const error = (errors as Record<string, FieldError | undefined>)[name]
      return (
        <TextInput
          {...rest}
          hasWarning={Boolean(error)}
          onValueChange={(next) => {
            onChange(next)
            onValueChange?.(next)
          }}
          value={value ?? ''}
          warningText={error?.message}
        />
      )
    }}
    rules={rules}
  />
)
